module.exports = __webpack_public_path__ + "img/mustard.753c6701.jpeg";